import React from "react";
import { Box, Card, Typography, CardContent, Grid, Divider } from "@material-ui/core";
import "moment-timezone";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import TabHeader from "src/components/TabHeader/TabHeader";
import { useStyles } from "./style";
import { NarcoticsReport } from "./components/NarcoticsReport";
import { RevenueReport } from "./components/RevenueReport";
import { RevenueCollectionReportBTWise } from "./components/RevenueCollectionReportBTWise";

interface Props {}

export function Listing({}: Props): React.ReactElement {
  const classes = useStyles();

  const moduleName = "Vehicle Reports";
  const pageHeading = "Vehicle Reports";

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: wHeight }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid md={8}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}>{pageHeading}</Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider />
          <NarcoticsReport />
          <RevenueReport />
          <RevenueCollectionReportBTWise />
        </CardContent>
      </Card>
    </>
  );
}
